import React from 'react';

interface ApiErrorBannerProps {
  error: Error | null | undefined;
  className?: string;
}

// ApiErrorBanner renders a standard danger-style alert with the error's
// message. Returns null when error is null/undefined, so callers can
// drop it in unconditionally. Used across pages that consume
// usePaginatedQuery / useQuery / orval-generated hooks so API failures
// (400s, 500s, validation errors) are always surfaced rather than
// silently swallowed.
export const ApiErrorBanner: React.FC<ApiErrorBannerProps> = ({ error, className }) => {
  if (!error) return null;
  return (
    <div
      className={`alert alert-danger m-2 mb-0 py-2 small ${className ?? ''}`}
      role="alert"
    >
      {error.message || 'Request failed'}
    </div>
  );
};
